module.exports = __webpack_public_path__ + "img/class3.fe3e3e2d.png";